import styled from 'styled-components'
import { MAIN_BACKGROUND, PRIMARY_TEXT } from 'constants/colors'

export const StyledIconButton = styled.div`
  > button {
    padding: 8px;
    color: ${PRIMARY_TEXT};

    &:hover {
      background-color: ${MAIN_BACKGROUND};
    }
  }
`
